import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { BusinessHeader, BusinessFooter } from "./BusinessHome";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const SLOTS = ["Morning (10–12)", "Afternoon (2–4)", "Evening (5–7)"];

export default function BusinessDemo() {
  const nav = useNavigate();
  const [f, setF] = useState({
    contact_name: "", restaurant_name: "", phone: "", email: "",
    city: "", num_outlets: 1, preferred_date: "", preferred_time_slot: SLOTS[0], notes: "",
  });
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!f.contact_name || !f.phone || !f.email) {
      toast.error("Please fill required fields");
      return;
    }
    setBusy(true);
    try {
      const res = await api.post("/demo-bookings", f);
      if (res.data.duplicate) toast.info("You already have a pending demo — we'll be in touch.");
      else toast.success("Booked! Redirecting…");
      nav("/business/demo-confirmed?slot=" + encodeURIComponent(f.preferred_time_slot) + "&date=" + encodeURIComponent(f.preferred_date));
    } catch (e) {
      toast.error(e.response?.data?.detail || "Booking failed");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen">
      <BusinessHeader />
      <div className="max-w-2xl mx-auto px-4 py-10">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-dark">Book a Free Demo</h1>
        <p className="text-brand-dark/60 mt-1">30 minutes. We'll set up a demo restaurant to match your menu.</p>

        <div className="mt-6 bg-white rounded-2xl border border-brand-dark/5 p-5 space-y-3">
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="text-xs text-brand-dark/60">Your name*</label>
              <Input value={f.contact_name} onChange={(e) => setF({ ...f, contact_name: e.target.value })} data-testid="d-name" />
            </div>
            <div>
              <label className="text-xs text-brand-dark/60">Restaurant name*</label>
              <Input value={f.restaurant_name} onChange={(e) => setF({ ...f, restaurant_name: e.target.value })} data-testid="d-restname" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="text-xs text-brand-dark/60">Phone*</label>
              <Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="d-phone" />
            </div>
            <div>
              <label className="text-xs text-brand-dark/60">Email*</label>
              <Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="d-email" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="text-xs text-brand-dark/60">City</label>
              <Input value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} />
            </div>
            <div>
              <label className="text-xs text-brand-dark/60"># Outlets</label>
              <Input type="number" min={1} value={f.num_outlets} onChange={(e) => setF({ ...f, num_outlets: +e.target.value })} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="text-xs text-brand-dark/60">Preferred date</label>
              <Input type="date" value={f.preferred_date} onChange={(e) => setF({ ...f, preferred_date: e.target.value })} />
            </div>
            <div>
              <label className="text-xs text-brand-dark/60">Preferred slot</label>
              <select value={f.preferred_time_slot} onChange={(e) => setF({ ...f, preferred_time_slot: e.target.value })} className="w-full h-10 rounded border border-input px-2">
                {SLOTS.map((s) => <option key={s}>{s}</option>)}
              </select>
            </div>
          </div>
          <div>
            <label className="text-xs text-brand-dark/60">Anything specific we should show?</label>
            <textarea value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} className="w-full min-h-[70px] rounded border border-input p-2 text-sm" />
          </div>
          <Button onClick={submit} disabled={busy} className="w-full bg-brand-orange hover:bg-brand-orange-dark text-white" data-testid="d-submit">
            {busy ? "Booking…" : "Book Demo"}
          </Button>
        </div>
      </div>
      <BusinessFooter />
    </div>
  );
}
